import React, { useEffect, useState } from 'react';
import { publicApi } from '../../lib/api';
import OfferAd from './OfferAd';
import { Loader2 } from 'lucide-react';

export default function OfferList({ category, empty = 'No offers available yet.' }) {
  const [offers, setOffers] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setOffers(null);
    publicApi.listOffers(category)
      .then((data) => { if (!cancelled) setOffers(data || []); })
      .catch(() => { if (!cancelled) setError('Failed to load offers.'); });
    return () => { cancelled = true; };
  }, [category]);

  if (error) return <div className="text-center text-slate-500 py-12">{error}</div>;
  if (offers === null) return (
    <div className="flex items-center justify-center py-16 text-slate-400">
      <Loader2 className="w-6 h-6 animate-spin" />
    </div>
  );
  if (offers.length === 0) return <div className="text-center text-slate-500 py-12">{empty}</div>;

  return (
    <div className="space-y-6">
      {offers.map((o, i) => (
        <OfferAd key={o.id} offer={o} index={i} />
      ))}
    </div>
  );
}
